import React, {useContext} from "react";
import Context from "./EventsProvider";
import styled from "@emotion/styled";

import { Colors, Sizes } from "../../styles";


const LanguageToggler = () => {
	const { data: { params },
		actions: { setParams }, 
	} = useContext(Context);

	const setEventsLanguage = (language) => {
		setParams((currentValue) => {
			const newParams = { ...currentValue, lang: language };
			return newParams;
		});
	}

	const langTogglerClass = (btnLang) => {
		if (params.lang === btnLang) return "active";
		return "";
	}

	return (
		<LanguageTogglerList>
			<li>
				<LangButton 
					className={langTogglerClass("en")} 
					type="button"
					onClick={() => setEventsLanguage("en")}
				>
                    EN
				</LangButton>
			</li>
			<li>
				<LangButton 
					className={langTogglerClass("fr")} 
					type="button"
					onClick={() => setEventsLanguage("fr")}
				>
                    FR
				</LangButton>
			</li>
		</LanguageTogglerList>

	);

}

export default LanguageToggler;

const LangButton = styled.button`
	padding: 0.5rem;
	border-radius: 0.3rem 0 0 0.3rem;
	border: 0.1rem solid ${Colors.fp.pineGreen};
	background: ${Colors.fp.pineGreen5};
	color: rgba(0, 0, 0, 0.40);
	font-size: 1.5rem;

	&.active {
		border: 0.1rem solid ${Colors.fp.pineGreen};
		background: ${Colors.fp.pineGreen60};
		color: ${Colors.base.black};
	}

	&:hover,
	&:focus-visible,
    &:focus {
		padding-right: 0.5rem;

        &:after {  
            content: none;
        }
	}

	&:focus-visible {
		outline: solid 2px -webkit-focus-ring-color;
	}
`;

const LanguageTogglerList = styled.ul`
	list-style: none;
	margin: 2.5rem 0 0;
	padding: unset;
	display: inline-flex;
	justify-content: flex-start;

    @media only screen and (min-width: ${Sizes.screens.large}) {
        margin: unset;
        flex-basis: 6.7rem;
    }

    li {
        margin: 0;
    }

	li:last-of-type {
		${LangButton} {
			border-radius: 0 0.3rem 0.3rem 0;
		}
	}
`;
